export default "__VITE_ASSET__7fbd272e__"